const specialNewlineCharacter = "\u200b\u200b";

export type ILargeControlText = {
  line1: string;
  line2: string | null;
};

export function getLargeControlText(text: string): ILargeControlText {
  const controlText = text ?? "";

  let line1 = controlText;
  let line2 = null;

  const idxChar = controlText.lastIndexOf(specialNewlineCharacter);
  if (idxChar !== -1) {
    line1 = controlText.substr(0, idxChar);
    line2 = controlText.substr(idxChar + 2);
  } else {
    const idxSpace = controlText.lastIndexOf(" ");
    if (idxSpace !== -1) {
      line1 = controlText.substr(0, idxSpace);
      line2 = controlText.substr(idxSpace + 1);
    }
  }
  return {
    line1,
    line2,
  };
}
